import React from "react";
import _ from "lodash";
import { branch } from "baobab-react/higher-order";
import PlayerProcedure from "./PlayerProcedure";
import PlayerShowMode from "./PlayerShowMode";
import { getConfigParam } from "../../utils/config";

class Player extends React.PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			confirmedVoice: false
		};
	}


	render() {
		let player;

			if (!_.isUndefined(this.props.activity)) {
				if (this.props.activity.startInShowMode !== true || getConfigParam("startInShowMode") === false) {
					player = <PlayerProcedure activity={this.props.activity} />;
				} else {
					player = <PlayerShowMode activity={this.props.activity} />;
				}
			} else {
				player = <div></div>;
			}
		


		return player;
	}
}

export default branch({
	activity: ["activity"],
	_config: ["_config"]
}, Player);